import Http from '@/bll/Http'
import { isDev } from '@/config/dev'
import { getApiUrl } from '@/config/http.config'
import { getApiType } from '@/context/user'

/**
 * 获取商户门店信息
 */
export const getTenanBranch = async (param2) => {
  const obj = {
    name: '获取商户门店信息',
    key: 'gettenanbranch',
    url: 'api/v1/Tenant/gettenanbranch',
    param2,
    cacheTime: 180,
    isCache: false
  }
  if (getApiType() == 'cy') {
    obj.host = getApiUrl('epicureApi')
    obj.url = 'platform/api/Tenant/gettenanbranch'
  }
  const http = new Http(obj)
  return await http.post()
}

/**
 * 获取购买列表（QueryBuyBranchs）
 */
export const queryBuyBranchs = async (param2) => {
  const obj = {
    name: '获取购买列表（天店管家）',
    key: 'QueryBuyBranchs',
    url: 'api/v1/valueaddedproductpurchase/QueryBuyBranchs',
    param2,
    cacheTime: 180,
    isCache: false
  }
  if (getApiType() == 'cy') {
    obj.host = getApiUrl('epicureApi')
    obj.url = 'api/v1/valueaddedproductpurchase/QueryBuyBranchs'
  }
  const http = new Http(obj)
  return await http.post()
}

/**
 * 获取授权经销商信息
 */
export const getTenantAgent = async (param2) => {
  const obj = {
    name: '获取授权经销商信息',
    key: 'QueryTenantAgent',
    url: 'api/v1/Tenant/QueryTenantAgent',
    param2,
    cacheTime: 180,
    isCache: false
  }
  if (getApiType() == 'cy') {
    obj.host = getApiUrl('epicureApi')
    obj.url = 'platform/api/Tenant/QueryTenantAgent'
  }
  const http = new Http(obj)
  return await http.post()
}

/**
 * 获取商户和操作员信息
 */
export const getTenantInfo = async (param2) => {
  const obj = {
    name: '获取商户和操作员信息',
    key: 'GetTenantInfo',
    url: 'api/v1/Tenant/querytenantinfo',
    cacheTime: 180,
    isCache: false
  }
  if (getApiType() == 'cy') {
    obj.host = getApiUrl('epicureApi')
    obj.url = 'platform/api/Tenant/QueryTenantInfo'
  }
  const http = new Http(obj)
  return await http.post()
}

/**
 * 获取商户授权
 */
export const getTenantAuth = async () => {
  const obj = {
    name: '获取商户授权',
    key: 'getTenantAuth',
    url: 'api/v1/TenantRight/tenantauthorization',
    cacheTime: 180,
    isCache: false
  }
  const http = new Http(obj)
  return await http.get()
}

/**
 * 获取商户订单
 */
export const getTenantOrder = async () => {
  const obj = {
    name: '获取商户订单',
    key: 'getTenantOrder',
    url: 'api/v1/TenantRight/myorder',
    cacheTime: 180,
    isCache: false
  }
  const http = new Http(obj)
  return await http.get()
}

/**
 * 修改发票信息
 */
export const changeReceiptInfo = async (param2) => {
  const obj = {
    name: '修改发票信息',
    key: 'changeReceiptInfo',
    url: 'api/v1/TenantRight/changereceiptinfo',
    param2,
    cacheTime: 180,
    isCache: false
  }
  const http = new Http(obj)
  return await http.post()
}

/**
 * 获取软件服务购买协议
 */
export const getSoftwareAgreement = async () => {
  const obj = {
    name: '获取软件服务购买协议',
    key: 'getSoftwareAgreement',
    url: 'api/v1/TenantCloudService/agreementcontenthtml',
    cacheTime: 180,
    isCache: false
  }
  if (getApiType() == 'cy') {
    obj.host = getApiUrl('epicureApi')
    obj.url = 'platform/api/Tenant/getagreementcontenthtml'
  }
  const http = new Http(obj)
  if (getApiType() == 'cy') {
    return await http.post()
  } else {
    return await http.get()
  }
}

/**
 * 获取发票地址
 */
export const getReceipturl = async () => {
  const obj = {
    name: '获取发票地址',
    key: 'getReceipturl',
    url: 'api/v1/TenantRight/myreceipturl',
    cacheTime: 180,
    isCache: false
  }
  if (getApiType() == 'cy') {
    obj.host = getApiUrl('epicureApi')
    obj.url = 'platform/api/Tenant/myreceipturl'
  }
  const http = new Http(obj)
  return await http.get()
}
